var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseIcon = function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#678093",
    d: "m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
  })));
};
export { SvgCloseIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjE5MiA2LjM0Mzk5TDExLjk0OSAxMC41ODZMNy43MDY5NyA2LjM0Mzk5TDYuMjkyOTcgNy43NTc5OUwxMC41MzUgMTJMNi4yOTI5NyAxNi4yNDJMNy43MDY5NyAxNy42NTZMMTEuOTQ5IDEzLjQxNEwxNi4xOTIgMTcuNjU2TDE3LjYwNiAxNi4yNDJMMTMuMzY0IDEyTDE3LjYwNiA3Ljc1Nzk5TDE2LjE5MiA2LjM0Mzk5WiIgZmlsbD0iIzY3ODA5MyIvPgo8L3N2Zz4K";